function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
var Deposit = require('./overlays/deposit');
var Withdraw = require('./overlays/withdraw');
var Confirm = require('./overlays/confirm');
var GameSendAuth = require('./overlays/game-send-auth');
var GameReceive = require('./overlays/game-receive');
var Receive = require('./overlays/receive');
var WalletHistory = require('./overlays/wallet-history');
var SaitoCrypto = /*#__PURE__*/_createClass(function SaitoCrypto(app, mod) {
  var _app$browser;
  _classCallCheck(this, SaitoCrypto);
  this.app = app;
  this.mod = mod;

  // Feature CSS lives in mods/crypto (not the design-system bundle).
  if (app !== null && app !== void 0 && (_app$browser = app.browser) !== null && _app$browser !== void 0 && _app$browser.addStylesheet) {
    app.browser.addStylesheet('/crypto/style.css');
  }

  //'saito-crypto-deposit-render-request'
  this.deposit_overlay = new Deposit(app, mod);

  //'saito-crypto-withdraw-render-request'
  this.withdrawal_overlay = new Withdraw(app, mod);

  // Games: `saito-crypto-send-render-request` → Send (validate) → `saito-crypto-send-confirm-open-request` → Confirm + mycallback
  //        `saito-crypto-send-confirm` → result UI
  this.send_confirm_overlay = new Confirm(app, mod);

  // Game-specific outbound payment authorization (saito-game-crypto-send-auth-open-request)
  this.game_send_auth_overlay = new GameSendAuth(app, mod);

  // Game-specific inbound payment confirmation (saito-crypto-game-receive-render-request)
  this.game_receive_overlay = new GameReceive(app, mod);

  //'saito-crypto-receive-render-request'
  this.receive_overlay = new Receive(app, mod);
  this.wallet_history_overlay = new WalletHistory(app, mod);
});
module.exports = SaitoCrypto;